import React from 'react'

import CollectionCard, { CollectionCardProps } from '../CollectionCard'

import Section, { SectionProps } from './Section'

import './CollectionCardSection.scss'

const CollectionCardSection = (
  props: SectionProps & { cards: CollectionCardProps[] },
) => {
  return (
    <Section className={`collectionCardSection ${props.className}`} {...props}>
      <div className="collectionCardSection__cards">
        {props.cards.map(c => (
          <CollectionCard key={c.slug} {...c} />
        ))}
      </div>
      {props.children}
    </Section>
  )
}

export default CollectionCardSection
